'use strict';
var React = require('react');
var Components = require('./Components.jsx');
var appTypes = require('../../types/appTypes.js');

var Popup = React.createClass({
  propTypes: {
    components: React.PropTypes.array.isRequired,
    height: React.PropTypes.string.isRequired,
    events: React.PropTypes.object.isRequired,
    onLinkClick: React.PropTypes.func.isRequired
  },
  render: function () {
    return (
      <div key="popup-page" className='page-popup' style={{
        height: 0,
        zIndex : 20,
        position : 'absolute',
        left : 0,
        top : 0,
        width : 0
      }}>
        <Components components={this.props.components} events={this.props.events}/>
      </div>
    );
  },

  isCanEvents : function(){
    var r = false;
    var i = 0;
    var item;
    for(i;i < this.props.components.length;i++){
      item = this.props.components[i];
      if(item.closeByClickMode !== appTypes.PopupPanelClosePolicy.NONE){
        r = true;
        break;
      }
    }
    return r;
  }
});

module.exports = Popup;


// WEBPACK FOOTER //
// ./src/views/Page/Popup.jsx